

import React from 'react'
import classNames from 'classnames'
import ReduxStores from '../../../../stores/connects'
import { object, array } from 'prop-types'

class DropDown extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeGroupName: ''
    }
  }

  checkExclude (group) {
    if (!this.props.agentData || !this.props.agentData.agent || !this.props.agentData.groupCode) return false
    const { excludeAgent = [], excludeGroup = [] } = group
    const { agentData: { agent, groupCode } } = this.props
    let excludedCodes = [ ...excludeAgent, ...excludeGroup ].join(',').toUpperCase().split(',')
    if (excludedCodes.indexOf(agent.toString().toUpperCase()) !== -1 || excludedCodes.indexOf(groupCode.toString().toUpperCase()) !== -1) return true
    return false
  }

  generateLinks (group, groupName, type) {
    const { OptionFlags } = this.props
    const { activeGroupName } = this.state
    const links = group.links
    if (!links) return null
    if (this.checkExclude(group)) return null

    if (group.canSell && OptionFlags && OptionFlags[group.canSell] === 'N') {
      return null
    }
    if (type === 'heading') {
      return (
        <li onClick={this.setActiveGroupName.bind(this, groupName)} data-hxtrack-name={'header_dropdown_subnav_' + groupName}>{ group.strong ? <strong>{group.text}</strong> : group.text }<span className='caret hidden-sm hidden-md hidden-lg' /></li>
      )
    }

    return links.map(({ canSell, link, text, strong, divider }, key) => {
      if (OptionFlags && canSell && OptionFlags[canSell] === 'N') return null
      if (divider) {
        const dividerClasses = classNames({
          'hidden-xs': activeGroupName !== groupName && type !== 'singleGroup',
          'divider': true
        })
        return (
          <li key={key} className={dividerClasses} role='separator' />
        )
      }
      const liClasses = classNames({
        'hidden-xs': activeGroupName !== groupName && type !== 'singleGroup'
      })
      if (!link) {
        return (
          <li key={key} className={liClasses}>{ strong ? <strong>{text}</strong> : text }</li>
        )
      }
      return (
        <li key={key} className={liClasses}><a href={link} target='_parent'>{ strong ? <strong>{text}</strong> : text }</a></li>
      )
    })
  }

  setActiveGroupName (newName) {
    const { activeGroupName } = this.state
    if (activeGroupName === newName) newName = ''
    this.setState({
      activeGroupName: newName
    })
  }

  buildSingleGroup (group, groupName) {
    return (
      <ul className='dropdown-menu list-unstyled' role='menu'>
        { this.generateLinks(group, groupName, 'heading') }
        { this.generateLinks(group, groupName, 'singleGroup') }
      </ul>
    )
  }

  buildColumn (column) {
    return Object.keys(column).map(groupName => {
      const group = column[groupName]
      const heading = this.generateLinks(group, groupName, 'heading')
      const links = this.generateLinks(group, groupName)
      return (
        <ul key={groupName} className='list-unstyled' role='menu'>
          { heading }
          { links }
        </ul>
      )
    })
  }

  render () {
    const { columns } = this.props

    if (columns.length === 1 && Object.keys(columns[0]).length === 1) return this.buildSingleGroup(columns[0][ Object.keys(columns[0])[0] ], Object.keys(columns[0])[0])

    const items = columns.map((column, index) => {
      return (
        <div key={index} className='col-sm-6 col-md-3 megamenuNavCol'>
          { this.buildColumn(column) }
        </div>
      )
    })

    if (!items.length) return null
    return (
      <ul className='dropdown-menu list-unstyled col-md-12' role='menu'>
        <li>{ items }</li>
      </ul>
    )
  }
}

DropDown.propTypes = {
  columns: array,
  OptionFlags: object
}

export default ReduxStores(DropDown, ['agents'], true)
